<template>
    <div style="padding: 10px;">
        <el-dialog :visible.sync="showStatus" :title="title" width="50%">
            <el-form :show-message="false" :rules="rules" ref="form" :model="form">
                <el-form-item prop="businessId" :label="title=='装车单时间调整'?'装车单号':'记账单号'" :label-width="formLabelWidth">
                    <el-input v-model="form.businessId" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="time" label="时间" :label-width="formLabelWidth">
                    <el-date-picker style="width: 100%;" value-format="timestamp" v-model="form.time" type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-for="item in timeTypeOptions" :key="item.value" :label="item.label"
                    :label-width="formLabelWidth">
                    <el-date-picker style="width: 100%;" value-format="timestamp" v-model="form['time' + item.value]"
                        type="date" :placeholder="'请选择' + item.label" clearable>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="showStatus = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="submitInfo">确 定</el-button>
            </span>
        </el-dialog>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">采购</h1>
                <el-button size="mini" @click="purUpdateTime(0,'采购时间调整')" type="primary">采购时间调整</el-button>
                <el-button size="mini" @click="purUpdateTime(2,'采购退货时间调整')" type="primary">采购退货时间调整</el-button>
                <el-button size="mini" @click="purUpdateTime(5,'采购退补时间调整')" type="primary">采购退补时间调整</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">销售</h1>
                <el-button size="mini" @click="purUpdateTime(1,'销售时间调整')" type="primary">销售时间调整</el-button>
                <el-button size="mini" @click="purUpdateTime(3,'销售退货时间调整')" type="primary">销售退货时间调整</el-button>
                <el-button size="mini" @click="purUpdateTime(4,'装车单时间调整')" type="primary">装车单时间调整</el-button>
                <el-button size="mini" @click="purUpdateTime(6,'销售退补时间调整')" type="primary">销售退补时间调整</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'orderTimeUpdatePage',
    components: {},
    data() {
        return {
            formLabelWidth: '100',
            title:"",
            showStatus: false,
            form: {
                businessId: '',
                time: '',
            },
            type: 0,
            rules: {
                businessId: [
                    { required: true, message: '请输入记账单号', trigger: 'blur' },
                ],
                time: [
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
            }
        };
    },
    watch: {},
    computed: {
        // 采购(type=0)：1订单时间 2收货时间 3验收时间 4记账时间
        // 销售(type=1)：1订单时间 2复核时间 3出库记账时间
        timeTypeOptions() {
            if (this.type === 0) {
                return [
                    { label: '订单时间', value: 1 },
                    { label: '收货时间', value: 2 },
                    { label: '验收时间', value: 3 },
                    { label: '记账时间', value: 4 },
                ]
            }
            if (this.type === 1) {
                return [
                    { label: '订单时间', value: 1 },
                    { label: '复核时间', value: 2 },
                    { label: '出库记账时间', value: 3 },
                ]
            }
            return []
        }
    },
    methods: {
        purUpdateTime(val,title) {
            this.title=title
            this.showStatus = true
            this.type =val
            this.init()
        },
        submitInfo() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    // 原字段原样保留，额外追加填写了的时间字段（time1~time4）
                    let params = { businessId: this.form.businessId, time: this.form.time }
                    this.timeTypeOptions.forEach(item => {
                        let val = this.form['time' + item.value]
                        if (val !== '' && val !== null && val !== undefined) {
                            params['time' + item.value] = val
                        }
                    })
                    if (this.type == 1) {
                        this.$http.woApplyUpdateOderTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else if (this.type === 0) {
                        this.$http.pisplanorderUpdateOderTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }else if (this.type == 2) {
                        this.$http.pisplanorderupdateRgOderTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }else if (this.type == 3) {
                        this.$http.woApplyupdateRgOderTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }else if (this.type == 4) {
                        this.$http.woApplyupdateZcdTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }else if (this.type == 5) {
                        this.$http.pisplanorderUpdateRrOrderTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }else if (this.type == 6) {
                        this.$http.woApplyUpdateRrTime(params).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.showStatus = false;
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                } else {
                    return false;
                }
            });


        },
        init() {
            this.form = {
                businessId: '',
                time: '',
                time1: '',
                time2: '',
                time3: '',
                time4: '',
            }
        }
    },
    mounted() { }
};
</script>
<style  scoped></style>